import { WebPaths } from "./routes/Paths";
import { GlobalProvider } from "./GlobalContext";
import { Box, CssBaseline, ThemeProvider } from "@mui/material";
import {
	DarkTheme,
	LightTheme,
	//LightTheme,
	//CustomTheme
} from "./styles/themes";

const App = () => {
	return (
		<GlobalProvider>
			<ThemeProvider theme={LightTheme}>
				<CssBaseline />
				<Box sx={{ display: { xs: "none", sm: "none", md: "block" }, overflow: "hidden" }}>
					<WebPaths />
				</Box>
			</ThemeProvider>
		</GlobalProvider>
	);
};

export default App;
